import { Injectable } from '@angular/core';
import { RouterStateSnapshot, Router, RedirectCommand } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(state: RouterStateSnapshot): boolean | RedirectCommand {
    const url: string = state.url;
    const storedToken = this.authService.getStoredToken();
    if (this.authService.isLoggedIn || storedToken) {
      const dashboardPath = this.router.parseUrl('/dashboard');
      return new RedirectCommand(dashboardPath);
    }
    if (this.authService.connecting) return false;
    return true;
  }
}
